module.exports = __webpack_public_path__ + "static/media/temp-company-profile-background.d279e717.png";